// extracted by mini-css-extract-plugin
export var alertIcon = "_sv-0";